import { yup } from 'common/validation/initYup';

export const WidgetDamsSearchSchema = yup.object({});
